/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawerHeader_itemSearch = {
    readonly clearAppliedFiltersLinkReference: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly canBeDismissed: boolean | null;
    } | null> | null;
    readonly " $refType": "SbRespRefineMenuDrawerHeader_itemSearch";
};
export type SbRespRefineMenuDrawerHeader_itemSearch$data = SbRespRefineMenuDrawerHeader_itemSearch;
export type SbRespRefineMenuDrawerHeader_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuDrawerHeader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerHeader_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuDrawerHeader_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "clearAppliedFiltersLinkReference",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canBeDismissed",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '0c7d37dbacccb275c6b73ecb4d5a33a5';
export default node;
